import React, { useEffect, useState, useRef, useCallback, Fragment } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, IconButton } from '@mui/material'
import BackdropComponent from './backdrop'
import Divider from '@mui/material/Divider';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import MicIcon from '@mui/icons-material/Mic';
import { keyframes } from '@emotion/react';
import PersonalForm from './OrderForm'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import DeleteItemModal from './deleteItemModal'
import TextToImage from './generateImage'
import RecognizeSpeechChrome from './RecognizeSpeechChrome';
import EditComponent from './EditComponent';
import OrderForm from './OrderForm';

const scaleAnimation = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
`;



function App() {
  const [recording, setRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [transcription, setTranscription] = useState("");
  const [editSelect, setEditSelect] = useState();
  const [Items, setItems] = useState<any[]>([])
  const [detailsItems, setDetailItems] = useState<string[]>([])
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [loading, setLoading] = useState(false)
  const [deleteItem, setDeleteItem] = useState()
  const [isDeleteOpen, setIsDeleteOpen] = useState<boolean>(false)

  const setDeleteRow = (rowData: any) => {
    const newArr = Items.filter((val) => val !== rowData);
    setItems([...newArr])
  }

  const handleCancel = () => {
    setEditSelect(undefined)
  }

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorderRef.current = new MediaRecorder(stream);
    const chunks: any[] = [];

    mediaRecorderRef.current.ondataavailable = (event) => {
      chunks.push(event.data);
    };

    mediaRecorderRef.current.onstop = async () => {
      const blob: any = new Blob(chunks, { type: "audio/wav" });
      setAudioBlob(blob);
      if (blob) {
        await uploadAudio(blob)
      }
    };

    mediaRecorderRef.current.start();
    setRecording(true);
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }
    setRecording(false);
  };

  const uploadAudio = async (blob: any) => {
    if (!blob) return alert("No audio recorded!");

    const formData = new FormData();
    formData.append("audio", blob, "recording.wav");

    try {
      setLoading(true)
      const response = await axios.post(`https://api.update-ai.com/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const jsonText = response.data.items.replace(/^```json\n/, '').replace(/\n```$/, '');
      // Step 2: Parse the JSON string
      const items = await JSON.parse(jsonText);
      setItems(items)
      setTranscription(response.data.transcription);

      setLoading(false)
    } catch (err) {
      console.error("Error uploading file:", err);
      setLoading(false)
    }
  }

  useEffect(() => {
    const newList = Items.map((val: any) => val["item full description"])
    setDetailItems(newList)
  }, [Items])

  return (
    <div style={{ textAlign: "center" }}>
      {/* <RecognizeSpeechChrome /> */}
      <h1>سجل طلبك بالضغط على علامة الميكروفون</h1>
      <h2>Press on the mic button to make your order</h2>
      <TextToImage items={detailsItems} />
      <BackdropComponent open={loading} />
      {
        !recording ? <IconButton onClick={startRecording} sx={{ background: 'green' }}>
          <MicIcon sx={{ color: 'white' }} />
        </IconButton> :
          <IconButton onClick={stopRecording} sx={{ animation: `${scaleAnimation} 1s infinite` }}>
            <RadioButtonCheckedIcon sx={{ color: 'red' }} />
          </IconButton>
      }
      {recording &&
        <Fragment>
          <h2>اضغط مره اخره عند الانتهاء من تسجيل الرسالة الصوتية</h2>
          <h4>Press again when you finish your voice message</h4>
        </Fragment>
      }
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', px: 5 }}>
        {transcription && (
          <div>
            <h2>Transcription | النص المكتوب لطلبك</h2>
            <p>{transcription}</p>
          </div>
        )}
        {Items.length > 0 && <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, textAlign: 'center', direction: 'rtl', }} size="small">
            <TableHead>
              <TableRow>
                <TableCell align="right" sx={{ fontWeight: '700' }}>وصف المنتج الكامل</TableCell>
                <TableCell align="right" sx={{ fontWeight: '700' }}>اسم الماركة</TableCell>
                <TableCell align="right" sx={{ fontWeight: '700' }}>الكمية</TableCell>
                <TableCell align="right" sx={{ fontWeight: '700' }}>وحدة الوزن</TableCell>
                <TableCell align="right" sx={{ fontWeight: '700' }}>النكهة</TableCell>
                <TableCell align="right" sx={{ fontWeight: '700' }}>التعبئة</TableCell>
                <TableCell align="right" sx={{ fontWeight: '700' }}>الفئة</TableCell>
                <TableCell align="right" sx={{ fontWeight: '700' }}>الفئة الفرعية</TableCell>
                <TableCell align="right" sx={{ fontWeight: '700' }}>الفئة الفرعية الثانوية</TableCell>
                <TableCell align="center" sx={{ fontWeight: '700' }}>تعديل / حذف</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {Items && Items.map((row, idx) => {

                if (editSelect === row) { return <EditComponent setEditSelect={setEditSelect} row={row} setItems={setItems} index={idx} Items={Items} handleCancel={handleCancel} /> }
                else {
                  return <TableRow
                    key={row["item full description"] + "" + idx}
                  // sx={{ '&:last-child td, &:last-child th': { border: 1 } }}
                  >
                    <TableCell align="right">{row["item full description"] || ''}</TableCell>
                    <TableCell align="right">{row["brand name"] || ''}</TableCell>
                    <TableCell align="right">{row["quantity"] || ''}</TableCell>
                    <TableCell align="right">{row["weight unit"] || ''}</TableCell>
                    <TableCell align="right">{row["flavour"] || ''}</TableCell>
                    <TableCell align="right">{row["packaging"] || ''}</TableCell>
                    <TableCell align="right">{row["category"] || ''}</TableCell>
                    <TableCell align="right">{row["sub-category"] || ''}</TableCell>
                    <TableCell align="right">{row["sub-sub-category"] || ''}</TableCell>
                    <TableCell align="center">
                      <IconButton onClick={() => setEditSelect(row)} color='warning'>
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => {
                        setIsDeleteOpen(true);
                        setDeleteItem(row)
                      }} color='error'>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                }
              })}
            </TableBody>
          </Table>
        </TableContainer>}
      </Box>
      <Divider component="div" sx={{ my: 5 }} />
      <OrderForm transcribe={transcription} />    
      <DeleteItemModal
        handleDeleteItem={() => {
          setDeleteRow(deleteItem)
          setIsDeleteOpen(false)
        }}
        handleClose={() => setIsDeleteOpen(false)}
        open={isDeleteOpen} />
    </div>
  );
}

export default App;
